<div class="dropdown-field-wrapper" [attr.data-id]="getUniqueId()">
  <div class="dropdown-field-container" [ngClass]="{ 'error-state': !getControl().untouched && getControl().invalid }">
    <button
      type="button"
      class="dropdown-field-trigger"
      [class.has-value]="hasValue()"
      (click)="toggleDropdown()"
      [disabled]="getControl().disabled"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-haspopup]="true">
      <span class="dropdown-field-value" [class.placeholder]="!hasValue()">
        {{ getSelectedLabel() }}
      </span>
      <htx-icon
        [icon]="'expand_more'"
        [class.open]="isOpen()"
        class="dropdown-icon"></htx-icon>
    </button>

    @if (label()) {
      <label class="dropdown-field-label" [for]="'dropdown-' + getUniqueId()">
        {{ label() }}@if (required()) { <span class="required">*</span> }
      </label>
    }

    @if (isOpen()) {
      <div class="dropdown-menu">
        @for (option of options(); track option.value) {
          <button
            type="button"
            class="dropdown-item"
            [class.disabled]="option.disabled"
            [class.selected]="isSelected(option)"
            (click)="selectOption(option)"
            [disabled]="option.disabled">
            <span>{{ option.label }}</span>
            @if (multiple() && isSelected(option)) {
              <htx-icon [icon]="'check'" class="dropdown-item-check"></htx-icon>
            }
          </button>
        }
      </div>
    }
  </div>
</div>
